// src/pages/Gravel.js

import React from 'react';
import Hero from '../../components/Hero';
import { fetchPageContent } from '../../utils/api';
import useFetch from '../../hooks/useFetch';
import { Helmet } from 'react-helmet-async';
import InteriorHeroSkeleton from '../../components/InteriorHeroSkeleton';
import Footer from '../../components/Footer';
import FooterHero from '../../components/FooterHero';
import Testimonials from '../../components/Testimonials';
import Breadcrumbs from '../../components/Breadcrumbs';
import ProjectsSlider from '../../components/ProjectsSlider';
import Sidebar from '../../components/Sidebar';
import FaqComponent from '../../components/FaqComponent';

const GarageSlabs = () => {
  const { data: heroContent, data: interiorPageContent, loading } = useFetch(() => fetchPageContent('garage-slabs'), 'garage-slabs');
  // const faqs = [
  //   {
  //     question: "What types of gravel do you offer?",
  //     answer: "We offer a wide variety of gravel types, including crushed stone, pea gravel, and decorative gravel, in various sizes and colors to suit your specific needs."
  //   },
  //   {
  //     question: "How long does it take to install a gravel driveway?",
  //     answer: "The timeline for installation depends on the size and complexity of the project, but most gravel driveways can be completed in 1-3 days, including site preparation."
  //   },
  //   {
  //     question: "Is gravel a good option for drainage?",
  //     answer: "Yes, gravel is highly permeable, allowing water to flow through and reducing water accumulation. It’s an excellent choice for areas with heavy rainfall."
  //   },
  //   {
  //     question: "Can you repair or refresh my existing gravel driveway?",
  //     answer: "Absolutely! We offer maintenance services to repair, regrade, or refresh existing gravel driveways and pathways to keep them looking and functioning their best."
  //   },
  //   {
  //     question: "How do I maintain my gravel surface?",
  //     answer: "Regular maintenance includes raking the surface to ensure even distribution, replenishing gravel when needed, and addressing any drainage issues promptly."
  //   },
  //   {
  //     question: "What is included in your site preparation process?",
  //     answer: "Our site preparation includes excavation, leveling, and creating a stable base to ensure the gravel installation is durable and long-lasting."
  //   },
  //   {
  //     question: "Do you offer consultations to help decide on the best gravel solution?",
  //     answer: "Yes, we start every project with a consultation to understand your needs, evaluate the site, and help you select the perfect gravel for your project."
  //   },
  // ];

  return (
    <div>
      {loading ? (
        // Render HeroSkeleton component when loading
        <InteriorHeroSkeleton />
      ) : (
        (
          <>
            <Helmet>
              <title>Garage Slabs</title>
              <meta
                name="description"
                content="At Lizotte Construction, we understand that the foundation of any exceptional outdoor area is the groundwork it’s built upon."
              />
              <meta name="viewport" content="width=device-width, initial-scale=1.0" />
              <link rel="canonical" href="http://yourwebsite.com/home" />

              <link rel="preconnect" href="https://fonts.googleapis.com" />
              <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />
              <link href="https://fonts.googleapis.com/css2?family=Maven+Pro:wght@400..900&family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap" rel="stylesheet" />
              <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.3/dist/css/bootstrap.min.css" integrity="sha384-QWTKZyjpPEjISv5WaRU9OFeRpok6YctnYmDr5pNlyT2bRjXh0JMhjY6hW+ALEwIH" crossorigin="anonymous"></link>
              <script src="https://cdn.jsdelivr.net/npm/bootstrap@5.3.3/dist/js/bootstrap.bundle.min.js" integrity="sha384-YvpcrYf0tY3lHB60NNkmXc5s9fDVZLESaAA55NDzOxhy9GkcIdslK1eN7N6jIeHz" crossorigin="anonymous"></script>
            </Helmet>
            {loading ? (
              <p>Loading...</p>
            ) : (
              heroContent && <Hero className="interior-hero" content={heroContent.hero} featuredMedia={heroContent.featuredMedia} />
            )}
            {/* Other WhoWeAre Page Content */}
            {interiorPageContent?.interiorPageContent && (
              <div className='container'>
                <div className="main-page-content row justify-content-center align-items-stretch panel">
                  <div className='col-lg-12'>
                    <Breadcrumbs />
                    <div className='page-card'>
                      <div className='row align-items-stretch row-sidebar-page'>
                        <Sidebar />
                        <div className='col-9 col-sidebar-page'>
                          <div className='page-content' dangerouslySetInnerHTML={{ __html: interiorPageContent.interiorPageContent }} />
                          {/* <FaqComponent faqs={faqs} /> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </>
        )
      )}
      <ProjectsSlider />
      <Testimonials />
      <FooterHero />
      <Footer />
    </div>
  );
};

export default GarageSlabs;
